module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/font/notokr-bold.woff
// module id = DAeT
// module chunks = 0